import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const targetDeliveryDateTypesAdapter = getAdapter({ idFieldName: 'value' });

const targetDeliveryDateTypesSlice = createSlice({
  name: 'targetDeliveryDateTypes',
  initialState: targetDeliveryDateTypesAdapter.getInitialState(),
  reducers: {
    setTargetDeliveryDateTypes: (state, { payload: { targetDeliveryDateTypes } }) => {
      targetDeliveryDateTypesAdapter.setAll(state, targetDeliveryDateTypes);
    },
  },
});

const selectors = targetDeliveryDateTypesAdapter.getSelectors(({ targetDeliveryDateTypes }) => targetDeliveryDateTypes);

export const getTargetDeliveryDateTypes = (state) => selectors.selectAll(state);

export const {
  setTargetDeliveryDateTypes
} = targetDeliveryDateTypesSlice.actions;

export default targetDeliveryDateTypesSlice.reducer;